import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'

import BaseModal from 'components/Modals/BaseModal'
import { Button } from 'components/Forms'
import { closeModal } from 'store/actions/modals'
import { useProgress } from 'components/Hooks'

const ProgressModal = ({ progress }) => {
  const dispatch = useDispatch()
  const [Progress, progressValues, setProgress] = useProgress()

  useEffect(() => {
    setProgress(progress)
  }, [progress, setProgress])

  return (
    <BaseModal hideButtons title="components.PROGRESS_MODAL" shouldCloseOnOverlayClick={false}>
      <Progress />

      <div className="mt-3">
        <Button
          text="actions.CLOSE"
          className="btn btn-outline-secondary"
          onClick={() => dispatch(closeModal())}
          disabled={!!progressValues && !progressValues.done}
        />
      </div>
    </BaseModal>
  )
}

export default ProgressModal
